<template>
  <div class="retrieveCenter clearfix">
    <div class="main yuanjiao moshaBox">
      <h1>经销商 · 找回密码</h1>
      <div class="inputBox">
        <div class="form-group">
          <label>账号</label>
          <input type="text" v-model="user" class="form-control form-control-lg">
        </div>
        <div class="input-group mb-3">
          <input v-model="yzm" type="text" class="form-control form-control-lg" placeholder="通过预留手机号">
          <div class="input-group-append">
            <button v-if="!isSend" @click="getYzmFun" style="background:#FFFFFF;border: 1px solid #CED4DA;border-left: 0;" class="btn btn-light">
              <i style="font-size: 15px;" v-if="isLoadingYzm" class='iconfont icon-jiazai xuanzhuan text-success'></i>
              获取验证码
            </button>
            <button v-if="isSend" style="background:#FFFFFF;border: 1px solid #CED4DA;border-left: 0;" class="btn btn-light text-danger">
              {{isSendTime}}秒
            </button>
          </div>
        </div>
        <div class="form-group">
          <label>密码</label>
          <input type="password" v-model="pwd" class="form-control form-control-lg">
        </div>
        <div class="form-group">
          <label>重复密码</label>
          <input type="password" v-model="repwd" class="form-control form-control-lg">
        </div>
        <br>
        <button type="submit" class="btn btn-primary btn-block btn-lg" @click="loginFun">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          修改密码
        </button>
        <div class="description">
          <router-link tag='a' class="description huanchongZhong yuanjiao" to="/about">
            — 无法修改请联系我们 —
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'retrieveCenter',
  data () {
    return {
      user: '',
      pwd: '',
      repwd: '',
      yzm: '',
      isLoading: false,
      isLoadingYzm: false,
      isSend: false,
      isSendTime: 60,
      isCheck: false,
      timer: null
    }
  },
  components:{
  },
  methods:{
    // 找回密码
    getYzmFun() {
      return window.swal({
        title: '获取验证码',
        content: '单个账号每天仅能获取5次',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          // 加载中
          this.isLoadingYzm = true;
          resultCommons.apiSendcode(this,{user:this.user}).then(app=>{
            if(app.state === 200){
              // 成功
              this.isSend = true;
              this.timer = null;
              this.startCountdown();
              this.$message.showMsgBox({ type: 'success', content: app.message });
            }else{
              // 失败
              this.isSend = false;
              this.timer = null;
              this.$message.showMsgBox({ type: 'warning', content: app.message });
            }
            this.isLoadingYzm = false;
            this.isSendTime = 60;
          });
        }
      });
    },
    // 登录
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      const that = this;
      // 可以执行登录
      resultCommons.apiSavepwd(this, { user: this.user, pwd: this.pwd , repwd: this.repwd , yzm: this.yzm }).then(app=>{
        if(app.state === 200){
          this.$message.showMsgBox({ type: 'success', content: app.message });
          // 延迟一秒跳转
          setTimeout(function(){
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            this.isLoading = false;
            that.$router.push({ path: '/login' });
          }, 500);
        }else{
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          this.$message.showMsgBox({ type: 'warning', content: app.message });
        }
      });
    },
    // 开始倒计时函数
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.isSendTime > 1) {
          this.isSendTime--;
        } else {
          this.isSend = false;
          this.timer = 60;
          clearInterval(this.timer);
        }
      }, 1000);
    }
  },
  mounted() {
    $('html').removeClass('scrollHide');
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  },
  beforeDestroy() {
    // 清除计时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style>
</style>
<style scoped lang='less'>
.retrieveCenter{
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  color: #000000;
  h1{
    text-align: center;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding-bottom: 50px;
  }
  div.main{
    width: 50vw;
    background:#FFFFFF;
    //background: rgba(0,0,0,0.3);
    padding:80px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    div.inputBox{
      width: 360px;
      div.description{
        text-align: center;
        margin-top: 50px;
      }
    }
  }
}
@media (max-width: 992px) {
  .aboutCenter{
    div.main{
      width: 100%;
      padding:100px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      div.inputBox{
        width: 100%;
        div.description{
          text-align: center;
          margin-top: 50px;
        }
      }
    }
  }
}
@media (max-width: 727px) {
  .aboutCenter{
    div.main{
      width: 100%;
      padding:100px 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      div.inputBox{
        width: 100%;
        div.description{
          text-align: center;
          margin-top: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/retrieve/Center.vue